import type { User } from "@shared/utils.user";
import { useUser as user } from "lib/user";

export function useUser(): Partial<User> {
  return user();
}
